<template>

  <svg
    t="1640064826930"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4357"
    width="64"
    height="64"
  ><path d="M752 62A70.00000031 70.00000031 0 0 1 822.00000031 132.00000031v759.99999938a70.00000031 70.00000031 0 0 1-70.00000031 70.00000031H272A70.00000031 70.00000031 0 0 1 201.99999969 891.99999969V132.00000031A70.00000031 70.00000031 0 0 1 272 62h480z m10.00000031 690h-500.00000062v139.99999969a10.00000031 10.00000031 0 0 0 10.00000031 10.00000031h480a10.00000031 10.00000031 0 0 0 10.00000031-10.00000031v-139.99999969zM512 792.00000031a40.00000031 40.00000031 0 1 1 0 79.99999969 40.00000031 40.00000031 0 0 1 0-79.99999969zM752 122H272a10.00000031 10.00000031 0 0 0-10.00000031 10.00000031v559.99999969h500.00000062V132.00000031a10.00000031 10.00000031 0 0 0-10.00000031-10.00000031zM591.99999969 171.99999969v60h-159.99999938V171.99999969h159.99999938z" p-id="4358" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconMobile',
} as DefineComponent
</script>